module.exports = __webpack_public_path__ + "static/img/footer2.96e6bb59.png";